import React from 'react';

// Types
import { Member, OrganizationRoleType } from 'Shared/types/Member.type';

// Components
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import WpBadge from 'Wpds/components/badge/WpBadge';

// Styles
import './MemberName.scss';

type Props = {
  member: Member;
};

const MemberName = ({ member }: Props) => {
  const isAdmin = member.organizationRole === OrganizationRoleType.admin;
  const isThirdPartyUser = !member?.primary;

  const baseClassName = 'MemberName';
  return (
    <div className={baseClassName}>
      <WpAvatar avatar={member.avatar} />

      <div className={`${baseClassName}__wrapper`}>
        <p className={`${baseClassName}__wrapper__name`}>
          {member.fullName}
          {isAdmin && (
            <span className={`${baseClassName}__wrapper__name__badge`}>
              <WpBadge color="gray" size="sm" variant="bold">
                Admin
              </WpBadge>
            </span>
          )}
          {isThirdPartyUser && (
            <span className={`${baseClassName}__wrapper__name__badge`}>
              <WpBadge color="gray" size="sm" variant="bold">
                Third Party User
              </WpBadge>
            </span>
          )}
        </p>
        <div className={`${baseClassName}__wrapper__email`}>{member.email}</div>
      </div>
    </div>
  );
};

export default MemberName;
